import React, { Fragment, useState } from 'react';

import styled from 'styled-components';
import { ReactComponent as CopySvg} from '../../assets/svgs/icons/CopyIcon.svg';
import Colors from '../../constants/colors';

const StyledCopy = styled(CopySvg)`
  height: 16px;
  width: 16px;
`;

const IconWrapper = styled.div`
  margin-left: 10px;
  background: transparent;
  width: 25px;
  height: 25px;
  border-radius: 12.5px;
  transition: .3s ease all;

  &:hover {
    cursor: pointer;
    background: ${Colors.BTN_BACK};
  }
`;

const StyledTextArea = styled.textarea`
  opacity: 0;
  height: 0px;
  position: absolute;
  left: -5000px;
`;

const TextDetail = styled.p`
  font-size: 16px;
  font-weight: 600;
  margin: 0px;
  color: #333;
`;

const SuccessText = styled.p`
  font-family: Inter, sans-serif!important;
  font-size: 12px;
  font-weight: normal;
  margin: 0px 0px 0px 10px;
  color: ${Colors.PLACEHOLDER_GRAY};
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

function CopyText({text}) {

  const [isClicked, setClicked] = useState(false);
  const textArea = React.createRef();

  const handleCopy = () => {
    const el = textArea.current;
    el.select();
    document.execCommand("copy");
    setClicked(true);

    setTimeout(() => {
     setClicked(false);
    }, 2000);
  };

  const renderIcon = () => {
    return(
      isClicked ?
        <SuccessText>
          Copied
        </SuccessText>
      :
      <IconWrapper>
        <StyledCopy
          onClick={handleCopy}
        />
      </IconWrapper>
    );
  }

  return (
    <Fragment>
      <StyledTextArea
        ref={textArea}
        value={text}
      />
      <TextWrapper>
        <TextDetail>
          { text }
        </TextDetail>
        {
          text && renderIcon()
        }
      </TextWrapper>
    </Fragment>
  )
}

export default CopyText;